import { apiClient } from '@/shared/services/api';
import type { ApiResponse } from '@/features/auth/services/authApi';

export interface PaymentTerm {
  value: string;
  displayName: string;
  days: number;
  description: string;
}

export interface County {
  name: string;
  code: string;
  countyNumber: number;
}

export interface InvoiceStatusOption {
  value: number;
  name: string;
  description: string;
}

export interface VatRateOption {
  rate: number;
  name: string;
  description: string;
}

export interface CallLogMetadataOption {
  value: number;
  name: string;
}

export interface OrderStatusOption {
  value: number;
  name: string;
  displayName: string;
  description: string;
}

export interface OrderStatusOption {
  value: number;
  name: string;
  displayName: string;
  description: string;
}

export const metadataApi = {
  getPaymentTerms: async (): Promise<PaymentTerm[]> => {
    const { data } = await apiClient.get<ApiResponse<PaymentTerm[]>>(
      '/Metadata/payment-terms'
    );
    return data.data;
  },

  getCounties: async (): Promise<County[]> => {
    const { data } = await apiClient.get<ApiResponse<County[]>>(
      '/Counties'
    );
    return data.data;
  },

  getInvoiceStatuses: async (): Promise<InvoiceStatusOption[]> => {
    const { data } = await apiClient.get<ApiResponse<InvoiceStatusOption[]>>(
      '/Metadata/invoice-statuses'
    );
    return data.data;
  },

  getVatRates: async (): Promise<VatRateOption[]> => {
    const { data } = await apiClient.get<ApiResponse<VatRateOption[]>>(
      '/Metadata/vat-rates'
    );
    return data.data;
  },

  getInquiryStatuses: async (): Promise<CallLogMetadataOption[]> => {
    const { data } = await apiClient.get<ApiResponse<CallLogMetadataOption[]>>(
      '/Metadata/inquiry-statuses'
    );
    return data.data;
  },

  getInquiryPriorities: async (): Promise<CallLogMetadataOption[]> => {
    const { data } = await apiClient.get<ApiResponse<CallLogMetadataOption[]>>(
      '/Metadata/inquiry-priorities'
    );
    return data.data;
  },

  getCallDirections: async (): Promise<CallLogMetadataOption[]> => {
    const { data } = await apiClient.get<ApiResponse<CallLogMetadataOption[]>>(
      '/Metadata/call-directions'
    );
    return data.data;
  },

  getCallSources: async (): Promise<CallLogMetadataOption[]> => {
    const { data } = await apiClient.get<ApiResponse<CallLogMetadataOption[]>>(
      '/Metadata/call-sources'
    );
    return data.data;
  },

  getOrderStatuses: async (): Promise<OrderStatusOption[]> => {
    const { data } = await apiClient.get<ApiResponse<OrderStatusOption[]>>(
      '/Metadata/order-statuses'
    );
    return data.data;
  },
};